const NAME = "POSITIONS_CLASSIFICATION";

export default NAME;
